import { Component, OnInit } from "@angular/core";

@Component({
  selector: "gh-example-icons-component",
  templateUrl: "./example-icons.component.html",
  styleUrls: [],
})
export class ExampleIconsComponent implements OnInit {
  ngOnInit(): void {
    // eslint-disable-next-line no-console
    console.log("init-example-icons");
  }
}
